import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';

/**
 * Native nav module — registers the NavContentBlueprint extension that replaces
 * the legacy `Root` / `SidebarPage` / `AppRouter` combination previously carried
 * inside `convertLegacyAppRoot`.
 */
export const navModule = createFrontendModule({
    pluginId: 'app',
    extensions: [SidebarContent],
});

